module.exports = __webpack_public_path__ + "static/media/logo1.59b248d1.svg";